import { EditProjectMilestoneModal } from "@/containers/Project/components";
import MilestoneStatusActionCommentModal from "@/containers/Project/components/Milestones/components/Modals/MilestoneStatus/MilestoneStatusActionCommentModal";
import * as S from "@/containers/Project/components/styled";
import { PROJECT_STATUS } from "@/enums";
import { useProjectContext } from "@/providers";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { MilestonePanel } from "./MilestonePanel";

const MilestoneList = () => {
  const intl = useIntl();
  const { project, currentSchedule } = useProjectContext();

  const [milestones, setMilestones] = useState([]);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (project?.status) {
      setIsActive(project.status === PROJECT_STATUS.project.active.id);
    }
  }, [project?.status]);

  useEffect(() => {
    if (project?.schedules && currentSchedule) {
      const targetSchedule = project.schedules.find(
        (schedule) => schedule.id === currentSchedule
      );
      setMilestones(targetSchedule?.milestones);
    }
  }, [currentSchedule, project?.schedules]);

  const createMilestonePanelsFlatRecursive = (
    milestonesToAdd,
    flattenedMilestones = [],
    childLevel = 0,
    parentId = null,
    topLevelParent = null,
    skuRequired
  ) => {
    let targetDatesRequiredIndex = null;

    if (childLevel === 0) {
      targetDatesRequiredIndex = null;

      const currentScheduleIndex = milestonesToAdd.findIndex(
        (scheduleMilestone) => scheduleMilestone.targetDatesRequired
      );

      targetDatesRequiredIndex =
        currentScheduleIndex !== -1
          ? currentScheduleIndex
          : targetDatesRequiredIndex;
    }

    milestonesToAdd.forEach((milestoneItem, index) => {
      if (!skuRequired && milestoneItem.areProjectSkusRequired) {
        skuRequired = true;
      }

      const currentChildLevel = childLevel;

      const targetDatesRequired =
        targetDatesRequiredIndex !== null && index >= targetDatesRequiredIndex;

      flattenedMilestones.push(
        <MilestonePanel
          key={milestoneItem.id}
          milestone={milestoneItem}
          childLevel={currentChildLevel}
          parentId={parentId}
          topLevelParent={topLevelParent}
          targetDatesRequired={targetDatesRequired}
          skuRequired={skuRequired}
        />
      );

      if (milestoneItem.childMilestones?.length > 0) {
        createMilestonePanelsFlatRecursive(
          milestoneItem.childMilestones,
          flattenedMilestones,
          currentChildLevel + 1,
          milestoneItem.id,
          !topLevelParent ? milestoneItem.id : topLevelParent,
          skuRequired
        );
      }
    });
    return flattenedMilestones;
  };

  return (
    <>
      {isActive && milestones?.length === 0 && (
        <S.StyledAlert
          type="warning"
          message={intl.formatMessage({
            id: "milestonesList.loadingMilestone",
          })}
        />
      )}
      {milestones?.length > 0 && (
        <>{createMilestonePanelsFlatRecursive(milestones)}</>
      )}
      <EditProjectMilestoneModal />
      <MilestoneStatusActionCommentModal />
    </>
  );
};

export { MilestoneList };
